import React, { FC, useEffect, useState } from 'react';
import {
    Grid,
    Typography,
    Paper,
    Button,
    IconButton,
    TextField,
    Divider,
    Box,
    FormLabel,
    Autocomplete,
    CircularProgress,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import categoria_prueba from '../../../assets/image/categoria_prueba.png';
import { useShoppingCartStore } from '../../../hooks/useShoppingCartStore';
import { useAuthStore } from '../../../hooks/useAuthStore';
import { DetailShoppingCart } from '../../../types/slices/shoppingCartType';
import { useNavigate } from 'react-router-dom';
import { RoutesMap } from '../../../types';
import { useDocumentOfSalesStore } from '../../../hooks/useDocumentOfSalesStore';
import { useTypeSaleStore } from '../../../hooks/useTypeSaleStore';
import { useSearcherStore } from '../../../hooks/useSearcherStore';
import { useSupplierStore } from '../../../hooks/useSupplierStore';
import { CustomSnackbar } from '../../../components/common/CustomSnackbar/CustomSnackbar';
import { useWayToPayStore } from '../../../hooks/useWayToPayStore';
import { useTicketStore } from '../../../hooks/useTicketStore';

import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { useSaleChannelStore } from '../../../hooks/useSaleChannelStore';

export const ShoppingCartListV3: FC = () => {

    const navigate = useNavigate()
    const { user } = useAuthStore()
    const { selectedCustomer, setSelectedCustomer } = useSearcherStore()
    const { shoppingcart, selectedTypeDocument, selectedWayToPay, selectedSaleChannel,
        setSelectedTypeDocument, setSelectedSaleChannel, getShoppingCart, editCartProduct, deleteProductCart, assingCustomer, setSelectedWayToPay,
        changeGlobalDiscount } = useShoppingCartStore()
    const { documentOfSales, getDocumentOfSalesByCompany } = useDocumentOfSalesStore()
    const { typesSale, getTypesSale } = useTypeSaleStore()
    const { supppliers, getSuppliers } = useSupplierStore()
    const { wayToPay, getWayToPayByCompany } = useWayToPayStore()
    const { createTicket } = useTicketStore()
    const { salesChannels, getSalesChannels } = useSaleChannelStore()

    const [detailShoppingCart, setDetailShoppingCart] = useState<DetailShoppingCart[]>([])
    const [timerId, setTimerId] = useState<number | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [editDiscount, setEditDiscount] = useState<boolean>(false)
    const [globalDiscount, setGlobalDiscount] = useState<number>(0)

    useEffect(() => {
        getShoppingCartData()
    }, [])

    useEffect(() => {
        if (shoppingcart[0] && shoppingcart[0].id) setDetailShoppingCart(shoppingcart[0].detail)
    }, [shoppingcart])

    useEffect(() => {
        if (shoppingcart[0] && shoppingcart[0].idcustomer !== null && supppliers.length > 0) {
            const customer = supppliers.find(customer => customer.id === shoppingcart[0].idcustomer)
            setSelectedCustomer(customer || null)
        }
    }, [shoppingcart, supppliers])

    const getShoppingCartData = async () => {
        setLoading(true)
        await getShoppingCart({ iduser_created: user.id, status_ticket: 0 })
        await getDocumentOfSalesByCompany()
        await getTypesSale()
        await getSuppliers({ type: 1 })
        await getWayToPayByCompany()
        setLoading(false)
    }

    const handleChangeQuantity = async (iddetail: number, value: string) => {
        const newQuantity = parseInt(value) > 0 ? parseInt(value) : 0
        if (newQuantity < 0) return

        let oldQuantity: number

        setDetailShoppingCart((prevDetailShoppingCart) => {
            return prevDetailShoppingCart.map((detail) => {
                if (detail.id === iddetail) {
                    oldQuantity = detail.quantity
                    return { ...detail, quantity: newQuantity }
                }
                return detail
            })
        })

        if (timerId !== null) {
            clearTimeout(timerId)
        }

        const newTimerId: any = setTimeout(async () => {
            const response = await editCartProduct(iddetail, { quantity: newQuantity })
            if (response === true) {
                getShoppingCartData()
            } else {
                setDetailShoppingCart((prevDetailShoppingCart) => {
                    return prevDetailShoppingCart.map((detail) => {
                        if (detail.id === iddetail) {
                            return { ...detail, quantity: oldQuantity }
                        }
                        return detail
                    })
                });
            }
        }, 750)

        setTimerId(newTimerId)
    }

    const handleDeleteItem = async (iddetail: number) => {
        const response = await deleteProductCart(iddetail)
        if (response === true) getShoppingCartData()
    }

    const onGoBack = () => {
        navigate({ pathname: RoutesMap.SEARCHER_V3 })
    }

    const onChangeCustomer = async (rowSelected: any) => {
        setSelectedCustomer(rowSelected)

        if (shoppingcart[0] && shoppingcart[0].id) {
            await assingCustomer(shoppingcart[0].id, { iduser_created: user.id, idcustomer: (rowSelected?.id || null) })
        } else {
            if (rowSelected !== null) CustomSnackbar('success', 'Cliente seleccionado: ' + rowSelected.name_rz)
        }
    }

    const onGenerateTicket = async () => {
        if (!selectedTypeDocument) return CustomSnackbar('warning', 'Seleccione un tipo de documento')
        if (!selectedSaleChannel) return CustomSnackbar('warning', 'Seleccione un canal de venta')
        if (!selectedWayToPay) return CustomSnackbar('warning', 'Seleccione una forma de pago')
        // if (folio === '') return CustomSnackbar('warning', 'Ingrese el folio')

        const payload: any = {
            idshopping_cart: shoppingcart[0].id,
            idtype_document: selectedTypeDocument.id,
            idsale_channel: selectedSaleChannel.id,
            idway_to_pay: selectedWayToPay.id
            // folio: folio
        }
        const response = await createTicket(payload)
        if (response.id) navigate(`/preview-document/${response.id}`)
    }

    const handleChangeGlobalDiscount = async (idshop_cart: number, globaldiscount: number) => {
        await changeGlobalDiscount(idshop_cart, { global_discount: globaldiscount })
        getShoppingCart({ iduser_created: user.id })
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <IconButton
                    aria-label="Regresar"
                    onClick={onGoBack}
                >
                    <ArrowBackIcon />
                </IconButton>
            </Grid>
            {detailShoppingCart.map((item) => (
                <Grid item xs={12} key={item.id}>
                    <Paper elevation={3} style={{ padding: '15px', borderRadius: '8px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <img
                                    src={categoria_prueba}
                                    alt={item.name_product}
                                    style={{ width: '150px', borderRadius: '8px', height: '150px' }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="body1" sx={{ marginBottom: '8px' }}>{item.codesystem_product}</Typography>
                                <Typography variant="h6" sx={{ marginBottom: '8px' }}>{item.name_product}</Typography>
                                <Typography variant="body1" color="textSecondary" sx={{ marginBottom: '8px' }}>
                                    {item.description_product}
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                    $ {item.price}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Box sx={{ position: 'relative', height: '100%' }}>
                                    <TextField
                                        id={`quantity-${item.id}`}
                                        type="number"
                                        label="Cantidad"
                                        size="small"
                                        value={item.quantity}
                                        onChange={(e) => handleChangeQuantity(item.id, e.target.value)}
                                        style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                                    />
                                    <IconButton
                                        aria-label="Eliminar"
                                        onClick={() => handleDeleteItem(item.id)}
                                        style={{ position: 'absolute', top: 0, right: 0 }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            ))}
            <Grid item xs={12}>
                <Divider style={{ margin: '20px 0' }} />
            </Grid>
            <Grid item xs={12} md={6}>
                <Paper sx={{ borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'whitesmoke' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6" fontWeight="bold" sx={{ color: '#000000', marginBottom: '10px' }}>Resumen</Typography>
                            <Typography sx={{ color: '#000000' }}>Puntos acumulados:</Typography>
                            <Typography fontWeight="bolder">3 puntos</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ color: '#000000' }}>Total neto:</Typography>
                            <Typography fontWeight="bolder" color="#000000">$ {shoppingcart[0]?.net_total || '0'}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{ color: '#000000' }}>Descuento global:</Typography>
                            <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <TextField
                                    id="global_discount"
                                    type="number"
                                    name="global_discount"
                                    size="small"
                                    value={globalDiscount}
                                    onChange={(e) => {
                                        let value = parseInt(e.target.value);
                                        value = isNaN(value) ? 0 : Math.min(Math.max(value, 0), 100);
                                        setGlobalDiscount(value);
                                    }}
                                    inputProps={{
                                        min: 0,
                                        max: 100,
                                        maxLength: 3,
                                        readOnly: !editDiscount
                                    }}
                                    InputProps={{
                                        endAdornment: '%'
                                    }}
                                    sx={{
                                        maxWidth: '60%'
                                    }}
                                />
                                {!editDiscount
                                    ?
                                    <IconButton onClick={() => setEditDiscount(true)}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    :
                                    <Grid>
                                        <IconButton onClick={() => {
                                            setEditDiscount(false);
                                            handleChangeGlobalDiscount(shoppingcart[0].id, globalDiscount)
                                        }}>
                                            <SaveIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton onClick={() => setEditDiscount(false)}>
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{ color: '#000000' }}>Impuestos:</Typography>
                            <Typography fontWeight="bolder" color="#000000">$ {shoppingcart[0]?.IGV || '0'}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{ color: '#000000' }}>Total bruto:</Typography>
                            <Typography fontWeight="bolder" color="#000000">$ {shoppingcart[0]?.total || '0'}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
                <Paper sx={{ borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'whitesmoke' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6" fontWeight="bold" sx={{ color: '#000000', marginBottom: '10px' }}>Datos del documento</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormLabel sx={{ color: '#000000' }}>RUT:</FormLabel>
                            <Autocomplete
                                disablePortal
                                id="combo-box-customer"
                                value={selectedCustomer}
                                options={loading ? [] : supppliers}
                                getOptionLabel={(option) => option.rut || ""}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                fullWidth
                                renderInput={(params) => <TextField {...params} size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loading && <CircularProgress color="inherit" size={20} />}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }} />}
                                onChange={(e, newValue) => {
                                    onChangeCustomer(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormLabel sx={{ color: '#000000' }}>Razón social / Nombre:</FormLabel>
                            <TextField
                                id="name_rz"
                                type="text"
                                name="name_rz"
                                fullWidth
                                size="small"
                                value={selectedCustomer?.name_rz || ''}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                            <Autocomplete
                                disablePortal
                                id="combo-box-type-document"
                                value={selectedTypeDocument}
                                options={loading ? [] : documentOfSales}
                                getOptionLabel={(option) => option.name || ""}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                fullWidth
                                renderInput={(params) =>
                                    <TextField {...params} size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loading && <CircularProgress color="inherit" size={20} />}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                }
                                onChange={(e, newValue) => {
                                    setSelectedTypeDocument(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormLabel sx={{ color: '#000000' }}>Canal de venta:</FormLabel>
                            <Autocomplete
                                disablePortal
                                id="combo-box-sale-channel"
                                value={selectedSaleChannel}
                                options={loading ? [] : salesChannels}
                                getOptionLabel={(option) => option.name || ""}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                fullWidth
                                renderInput={(params) =>
                                    <TextField {...params} size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loading && <CircularProgress color="inherit" size={20} />}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                }
                                onChange={(e, newValue) => {
                                    setSelectedSaleChannel(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormLabel sx={{ color: '#000000' }}>Forma de pago:</FormLabel>
                            <Autocomplete
                                disablePortal
                                id="combo-box-way-to-pay"
                                value={selectedWayToPay}
                                options={loading ? [] : wayToPay}
                                getOptionLabel={(option) => option.wayToPay || ""}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                fullWidth
                                renderInput={(params) =>
                                    <TextField {...params} size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loading && <CircularProgress color="inherit" size={20} />}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                }
                                onChange={(e, newValue) => {
                                    setSelectedWayToPay(newValue);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{ borderRadius: '10px', marginTop: '20px' }}
                    onClick={() => onGenerateTicket()}
                >
                    EMITIR TICKET
                </Button>
            </Grid>
        </Grid>
    );
}